/**
 * Action Icons
 * Icons used for user actions like copying, calling, emailing, and printing
 */

import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/joy'

/**
 * Copy icon used for copying text to clipboard
 */
export const CopyIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon sx={{ width: 16, height: 16 }} {...props}>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <g clipPath="url(#clip0_394_4781)">
                <path
                    d="M6 10C6 8.11467 6 7.17133 6.586 6.586C7.17133 6 8.11467 6 10 6H10.6667C12.552 6 13.4953 6 14.0807 6.586C14.6667 7.17133 14.6667 8.11467 14.6667 10V10.6667C14.6667 12.552 14.6667 13.4953 14.0807 14.0807C13.4953 14.6667 12.552 14.6667 10.6667 14.6667H10C8.11467 14.6667 7.17133 14.6667 6.586 14.0807C6 13.4953 6 12.552 6 10.6667V10Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.333 5.99967C11.331 4.02834 11.3017 3.00701 10.7277 2.30767C10.6169 2.17277 10.4932 2.04907 10.3583 1.93834C9.61967 1.33301 8.52501 1.33301 6.33301 1.33301C4.14167 1.33301 3.04567 1.33301 2.30767 1.93834C2.17277 2.04907 2.04907 2.17277 1.93834 2.30767C1.33301 3.04634 1.33301 4.14101 1.33301 6.33301C1.33301 8.52434 1.33301 9.62034 1.93834 10.3583C2.04907 10.4932 2.17277 10.6169 2.30767 10.7277C3.00767 11.301 4.02767 11.3317 5.99967 11.333"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_394_4781">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    </SvgIcon>
)

/**
 * Call icon for phone calls
 */
export const CallIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon sx={{ width: 16, height: 16 }} {...props}>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
                d="M6.1057 3.808L5.83704 3.204C5.6617 2.80933 5.5737 2.612 5.44237 2.46067C5.27807 2.27114 5.06363 2.13181 4.8237 2.05867C4.63237 2 4.41637 2 3.9837 2C3.3517 2 3.0357 2 2.77037 2.12133C2.44305 2.28036 2.18969 2.55951 2.06304 2.90067C1.9677 3.176 1.99504 3.45933 2.0497 4.02667C2.63193 10.06 5.93993 13.3678 11.9737 13.95C12.5404 14.0047 12.8237 14.032 13.0997 13.9367C13.4405 13.81 13.7194 13.5569 13.8784 13.23C13.9997 12.964 13.9997 12.648 13.9997 12.016C13.9997 11.5833 13.9997 11.3673 13.941 11.176C13.8679 10.9361 13.7286 10.7216 13.539 10.5573C13.3884 10.426 13.1904 10.3387 12.7957 10.1627L12.1917 9.89467C11.7637 9.70467 11.5504 9.60933 11.333 9.58867C11.1249 9.56869 10.9151 9.59792 10.7204 9.674C10.517 9.75333 10.3377 9.90267 9.9777 10.2027C9.6197 10.5007 9.44104 10.6493 9.22237 10.7293C9.01248 10.8019 8.78865 10.825 8.56837 10.7967C8.3377 10.7633 8.1617 10.6687 7.80837 10.48C6.7117 9.89333 6.10637 9.28867 5.5197 8.19133C5.33104 7.838 5.23704 7.662 5.20304 7.43133C5.17464 7.21133 5.19746 6.98774 5.2697 6.778C5.3497 6.55867 5.49904 6.38 5.79704 6.022C6.09704 5.662 6.24704 5.48267 6.3257 5.27933C6.4017 5.08467 6.43104 4.87467 6.41104 4.66667C6.39104 4.45 6.2957 4.236 6.10504 3.808H6.1057Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
    </SvgIcon>
)

/**
 * Call AI icon for AI-powered phone calls
 */
export const CallAiIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon sx={{ width: 16, height: 16 }} {...props}>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <g clipPath="url(#clip0_394_4589)">
                <path
                    d="M5.43969 4.47499L5.17102 3.87099C4.99569 3.47633 4.90769 3.27899 4.77636 3.12766C4.61205 2.93813 4.39762 2.7988 4.15769 2.72566C3.96636 2.66699 3.75036 2.66699 3.31769 2.66699C2.68569 2.66699 2.36969 2.66699 2.10436 2.78833C1.77704 2.94735 1.52368 3.22651 1.39702 3.56766C1.30169 3.84299 1.32902 4.12633 1.38369 4.69366C1.96591 10.727 5.27391 14.0348 11.3077 14.617C11.8744 14.6717 12.1577 14.699 12.4337 14.6037C12.7745 14.477 13.0533 14.2239 13.2124 13.897C13.3337 13.631 13.3337 13.315 13.3337 12.683C13.3337 12.2503 13.3337 12.0343 13.275 11.843C13.2019 11.6031 13.0625 11.3886 12.873 11.2243C12.7224 11.093 12.5244 11.0057 12.1297 10.8297L11.5257 10.5617C11.0977 10.3717 10.8844 10.2763 10.667 10.2557C10.4589 10.2357 10.2491 10.2649 10.0544 10.341C9.85102 10.4203 9.67169 10.5697 9.31169 10.8697C8.95369 11.1677 8.77502 11.3163 8.55635 11.3963C8.34646 11.4689 8.12263 11.4919 7.90235 11.4637C7.67169 11.4303 7.49569 11.3357 7.14236 11.147C6.04569 10.5603 5.44036 9.95566 4.85369 8.85832C4.66502 8.50499 4.57102 8.32899 4.53702 8.09833C4.50862 7.87832 4.53144 7.65473 4.60369 7.44499C4.68369 7.22566 4.83302 7.04699 5.13102 6.68899C5.43102 6.32899 5.58102 6.14966 5.65969 5.94633C5.73569 5.75166 5.76502 5.54166 5.74502 5.33366C5.72502 5.11699 5.62969 4.90299 5.43902 4.47499H5.43969Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8.66699 5.91699L10.0485 1.77249C10.0832 1.66906 10.1495 1.57914 10.238 1.51544C10.3266 1.45173 10.4329 1.41745 10.542 1.41745C10.6511 1.41745 10.7574 1.45173 10.846 1.51544C10.9345 1.57914 11.0008 1.66906 11.0355 1.77249L12.417 5.91699M14.667 1.41699V5.91699M9.41699 4.41699H11.667"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_394_4589">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    </SvgIcon>
)

/**
 * Email icon for email actions
 */
export const EmailIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon sx={{ width: 19, height: 16 }} {...props}>
        <svg width="19" height="16" viewBox="0 0 19 16" fill="none">
            <path
                d="M4.91699 4.91602L7.36866 6.36602C8.79783 7.21102 9.36866 7.21102 10.7987 6.36602L13.2503 4.91602"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M0.76399 9.063C0.818157 11.6172 0.845657 12.8947 1.78816 13.8405C2.73066 14.7872 4.04232 14.8197 6.66649 14.8855C8.28316 14.9272 9.88482 14.9272 11.5015 14.8855C14.1257 14.8197 15.4373 14.7872 16.3798 13.8405C17.3223 12.8947 17.3498 11.6172 17.4048 9.063C17.4215 8.24133 17.4215 7.42466 17.4048 6.603C17.3498 4.04883 17.3223 2.77133 16.3798 1.8255C15.4373 0.87883 14.1257 0.84633 11.5015 0.780497C9.89008 0.739834 8.2779 0.739834 6.66649 0.780497C4.04232 0.84633 2.73066 0.87883 1.78816 1.8255C0.845657 2.77133 0.818157 4.04883 0.763157 6.603C0.745614 7.4229 0.746448 8.24309 0.76399 9.063Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    </SvgIcon>
)

/**
 * Email AI icon for AI-powered email actions
 */
export const EmailAiIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon sx={{ width: 20, height: 20 }} {...props}>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
                d="M5.83301 6.66699L8.28467 8.11699C9.71384 8.96199 10.2847 8.96199 11.7147 8.11699L14.1663 6.66699"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18.3333 9.583C18.3508 8.76134 18.3508 7.90467 18.3333 7.083C18.2792 4.52884 18.2383 4.52133 17.2958 3.5755C16.3533 2.62883 15.0417 2.59633 12.4175 2.5305C10.8061 2.48983 9.19392 2.48983 7.58251 2.5305C4.95834 2.59633 3.64667 2.62883 2.70417 3.5755C1.76167 4.52133 1.73417 5.79883 1.67917 8.353C1.66163 9.1729 1.66163 9.99309 1.67917 10.813C1.73417 13.3672 1.76167 14.6447 2.70417 15.5905C3.64667 16.5372 3.62584 16.6005 6.25001 16.6663C7.33751 16.6938 6.83334 16.6755 7.91668 16.6663"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10 17.708L11.7269 12.5274C11.7702 12.3981 11.8531 12.2857 11.9638 12.2061C12.0745 12.1264 12.2074 12.0836 12.3438 12.0836C12.4801 12.0836 12.613 12.1264 12.7237 12.2061C12.8344 12.2857 12.9173 12.3981 12.9606 12.5274L14.6875 17.708M17.5 12.083V17.708M10.9375 15.833H13.75"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    </SvgIcon>
)

/**
 * Print icon for printing functionality
 */
export const PrintIcon: React.FC = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <rect x="2" y="5" width="12" height="6" rx="1" stroke="currentColor" strokeWidth="1" />
        <path d="M4 5V2C4 1.44772 4.44772 1 5 1H11C11.5523 1 12 1.44772 12 2V5" stroke="currentColor" strokeWidth="1" />
        <circle cx="12" cy="8" r="0.5" fill="currentColor" />
    </svg>
)
